module.exports = __webpack_public_path__ + "media/images/homepage/flag-662d15ee5514c703a5734f5eaee99351.png";